<button cs-capture-cover [disabled]="disabled" [type]="type" [attr.aria-label]="ariaLabel || null"
  [attr.aria-pressed]="toggle ?? null">
</button>
@if (icon && !iconRight) {
  <cs-icon [name]="icon" [fill]="fillIcon"></cs-icon>
}
@if (!iconRight) {
  <ng-content select="cs-icon"></ng-content>
  <ng-content select="cs-spinner"></ng-content>
  <ng-content select="img"></ng-content>
}
<ng-content select="cs-label"></ng-content>
@if (label) {
  <cs-label>
    {{label}}
  </cs-label>
}
<ng-content></ng-content>
@if (iconRight) {
  <ng-content select="cs-icon"></ng-content>
  <ng-content select="cs-spinner"></ng-content>
}
@if (iconRight && iconRightIsButton) {
  <!-- its own button, raised above the capture cover so a tap on it does not reach the cover -->
  <button type="button" class="icon-right-button" data-e2e="icon-right-button" [disabled]="disabled"
    [attr.aria-label]="iconRightLabel || null" (click)="handleIconRightClick($event)">
    <cs-icon [name]="iconRight" [fill]="fillIcon" aria-hidden="true"></cs-icon>
  </button>
} @else if (iconRight) {
  <cs-icon [name]="iconRight" [fill]="fillIcon"></cs-icon>
}
@if (endIcon) {
  <cs-icon end-icon [name]="endIcon" aria-hidden="true"></cs-icon>
}